import { Component, Input } from '@angular/core';
import { getUniqueId } from '../../../functions/get-unique-id';

@Component({
  selector: 'app-label',
  imports: [],
  template: `
    <div class="tw-flex">
      <label for="id">{{ label }}</label>
      <div [id]="id">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: `
    label {
      font-weight: bold;
      padding-right: 4px;
    }
  `,
})
export class LabelComponent {
  @Input({ required: true })
  label: string;

  protected id = getUniqueId('app-label');
}
